import { render, staticRenderFns } from "./MessageLoader.vue?vue&type=template&id=16893138&scoped=true"
import script from "./MessageLoader.vue?vue&type=script&lang=js"
export * from "./MessageLoader.vue?vue&type=script&lang=js"
import style0 from "./MessageLoader.vue?vue&type=style&index=0&id=16893138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16893138",
  null
  
)

export default component.exports